import { FigmaNodeRenderFormat } from "@supernova-studio/model";
import { z } from "zod";
//
// Enums
//
export const DTOFigmaNodeRenderFormat = FigmaNodeRenderFormat;
//
// Read
//
export const DTOFigmaNodeOrigin = z.object({
    sourceId: z.string(),
    fileId: z.string().optional(),
    parentName: z.string().optional(),
});
//
// Write
//
/**
 * Properties that are available on all types of Figma node render requests
 */
const DTOFigmaNodeRenderInputBase = z.object({
    /**
     * Format in which the node must be rendered, png by default.
     */
    format: FigmaNodeRenderFormat.default("Png"),
    /**
     * Scale to apply to PNG images, can be between 1 and 4. Scale is ignored for other image formats.
     */
    scale: z.number().optional(),
});
/**
 * Figma node render request that uses source ID + node ID to identify the requested
 * node to render. The node ID can be obtained from the source's Figma node structure.
 */
export const DTOFigmaNodeRenderIdInput = DTOFigmaNodeRenderInputBase.extend({
    inputType: z
        .literal("NodeId")
        .optional()
        .transform((v) => v !== null && v !== void 0 ? v : "NodeId"),
    /**
     * Id of a design system's data source representing a linked Figma file
     */
    sourceId: z.string(),
    /**
     * Id of a node within the Figma file
     */
    figmaFileNodeId: z.string(),
});
/**
 * Figma node render request that uses Figma URL to identify the requested
 * node to render. The URL can be obtained by the user directly from the Figma app.
 */
export const DTOFigmaNodeRenderUrlInput = DTOFigmaNodeRenderInputBase.extend({
    inputType: z.literal("URL"),
    /**
     * Id of a design system's data source representing a linked Figma file
     */
    figmaNodeUrl: z.string(),
    /**
     * Brand persistent id to use in case a source has to be created for this render
     */
    brandPersistentId: z.string(),
});
/**
 * Figma node render request that uses Figma URL to identify the requested
 * node to render. The URL can be obtained by the user directly from the Figma app.
 */
export const DTOFigmaNodeRerenderInput = z.object({
    inputType: z.literal("Rerender"),
    /**
     * Persistent ID of an existing Figma node
     */
    figmaNodePersistentId: z.string(),
});
export const DTOFigmaNodeRenderInput = z.discriminatedUnion("inputType", [
    DTOFigmaNodeRenderIdInput,
    DTOFigmaNodeRenderUrlInput,
    DTOFigmaNodeRerenderInput,
]);
